import styled from 'styled-components/native';

import OrderStatusBadge from 'components/OrderStatusBadge';

export default styled(OrderStatusBadge)`
  margin-bottom: 12px;
  ${({ theme }) => theme.media.tablet && 'position: absolute;'};
`;
